export default {
  mobileS: 321,
  mobileM: 374,
  mobileL: 425,
  tablet: 769,
  laptopS: 1023,
  laptop: 1366,
  laptopL: 1439,
  laptopXL: 1600,
  desktop: 1919,
  desktopL: 2559,
};
